<template>
    <form class="card shadow-sm mt-4" @submit.prevent="handleSubmit">
        <div class="border-bottom px-3 py-2 text-blue-600 font-weight-bold">
            {{ $t('taxi.pages.summary.discount_codes.header') }}
        </div>

        <div class="d-flex align-items-center justify-content-between p-3" v-if="discount">
            <div>
                <div class="text-lg text-blue-600">
                    {{ discount.code }}
                </div>

                <div class="text-sm" v-if="discount.discount_type === discountTypePercent">
                    -{{ discount.discount_percent }}%
                </div>

                <div class="text-sm" v-else>
                    -{{ formatPrice(discount.discount_gross_value, travel.currency) }}
                </div>
            </div>

            <div>
                <button class="btn btn-outline-danger btn-sm" :title="$t('delete')" @click="handleRemove">
                    <font-awesome-icon icon="trash-alt" />
                </button>
            </div>
        </div>

        <div class="d-flex p-3" v-else>
            <input class="form-control" placeholder="Wpisz kod" required v-model="code">

            <v-submit-button :is-sending="isSending" class="btn btn-outline-primary ml-3 px-4">
                {{ $t('taxi.pages.summary.discount_codes.submit') }}
            </v-submit-button>
        </div>
    </form>
</template>

<script>
    import { mapGetters } from 'vuex';

    import VSubmitButton from '@components/VSubmitButton';
    import backofficeRepository from '@repositories/BackofficeRepository';
    import toastr from 'toastr';
    import backofficeMapsRepository from '@repositories/BackofficeMapsRepository';

    export default {
        components: {
            VSubmitButton,
        },

        data() {
            return {
                isSending: false,

                code: null,
            };
        },

        computed: {
            ...mapGetters({
                discountTypePercent: 'constants/discountTypePercent',
                discount: 'businessTaxi/getDiscount',
                cartData: 'businessTaxi/getCartData',
                travel: 'businessTaxi/getTravel',
                cartTotal: 'businessTaxi/getCartTotal',
            }),
        },

        methods: {
            handleSubmit() {
                this.isSending = true;

                //@INFO BT handles adults only
                backofficeRepository.voucherByClient(this.code, 'BUSINESS_TAXI', this.cartData.passengers.map(p => {return p.type!=='child'?'ADULT':'CHILD';}), this.cartTotal/100).then((data) => {
                    const isPercent = data.type!=='AMOUNT';
                    this.$store.dispatch('businessTaxi/setDiscount', {
                        'id': data.id,
                        'code': this.code,
                        'discount_type': isPercent?'percent':'amount',
                        'discount_percent': isPercent?data.valuePercentage:null,
                        'discount_net_value': isPercent?null:(data.valueAmount/1.23*100),
                        'discount_gross_value': isPercent?null:(data.valueAmount*100),
                        'discount_vat_value': isPercent?null:((data.valueAmount-data.valueAmount/1.23)*100),
                    });
                    this.code = null;
                }).catch((error) => {
                    //set toastr error from graphql response errors
                    toastr.error(backofficeMapsRepository.parseAPIError(error));
                    this.$store.dispatch('businessTaxi/setDiscount', null);
                }).finally(() => {
                    this.isSending = false;
                });
            },

            handleRemove() {
                this.$store.dispatch('businessTaxi/setDiscount', null);
            },
        },
    };
</script>
